import React,{useRef} from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import API from '../API';
import Swal from 'sweetalert2';
import '../Assets/CSS/TALFC.css';
import { GetRole, RootURL,APIURL } from '../Utils/Function';
import {UserChagePassword} from '../Components';
const Header =()=> {
    const _UserChangePassword = useRef();

    const Logout = async()=>{
        API({method : "delete",url:"/Authorization/"+localStorage.getItem("Authorization")}).then(res=>{
            if (res.status !== 200) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
                return;
            }

            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
                return;
            }
            localStorage.clear();
            window.location.href = '/';
        }).catch(res => {
            Swal.fire({
                icon: 'error',
                title: 'การเชื่อมต่อผิดพลาด',
                text: res.message+' ['+res.code+']',
            }).then(()=>{
                localStorage.clear();
                window.location.href = '/';
            })
        });
    }

    return (
        <>
        <header>
            <Navbar collapseOnSelect expand="lg" className="navbar navbar-light header">
                <Container fluid>
                    <Navbar.Brand href={RootURL()}>
                        <img className='navbar-brand' src={require('../Assets/Images/Logo/TALFC_Logo.png')} alt='Logo'/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse>
                        <Nav className="me-auto">
                            <Nav.Link href="#link">
                            <div className='text-end text-white'></div>
                            </Nav.Link>
                        </Nav>
                        <Nav style={{'marginRight':'150px'}}>
                            <Nav.Item className='text-end text-white mt-4' style={{'marginRight':'20px'}}>{sessionStorage.getItem('Name')}</Nav.Item>
                            <NavDropdown title={(<img src={APIURL()+'/Files/Avatar/'+localStorage.getItem('UserID')} className='avatar' alt='Avatar'/>)}>
                                {(GetRole() === 2?<NavDropdown.Item href="/Store">หน้าหลัก</NavDropdown.Item>:"")}
                                {(GetRole() === 3?<NavDropdown.Item href="/Staff">หน้าหลัก</NavDropdown.Item>:"")}
                                {(GetRole() === 9?<NavDropdown.Item href="/Admin">หน้าหลัก</NavDropdown.Item>:"")}
                                
                                {(GetRole() >=3?
                                <>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/Member">จัดการข้อมูลสมาชิก</NavDropdown.Item>
                                    <NavDropdown.Item href="/Card">จัดการบัตร</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/Shift">รายการรอบบัญชี</NavDropdown.Item>
                                    <NavDropdown.Item href="/Report/Sales">รายการยอดขาย</NavDropdown.Item>
                                    <NavDropdown.Item href="/Report/Topup">รายการยอดเติมเงิน</NavDropdown.Item>
                                    <NavDropdown.Item href="/Report/Aggregate">สรุปยกยอด</NavDropdown.Item>
                                    <NavDropdown.Item href="/Report/Summary">สรุปภาพรวม</NavDropdown.Item>
                                    <NavDropdown.Item href="/Report/Store">สรุปร้านค้า</NavDropdown.Item>

                                </>:"")}
                                {(GetRole() === 9?<NavDropdown.Item href="/Export/Month">ส่งออกรายงานสรุปร้านค้า</NavDropdown.Item>:"")}
                                <NavDropdown.Divider />
                                {(GetRole() === 9?<NavDropdown.Item href="/Store">จัดการร้านค้า</NavDropdown.Item>:"")}
                                {(GetRole() === 9?<NavDropdown.Divider />:"")}
                                {(GetRole() === 9?<NavDropdown.Item href="/User">จัดการเจ้าหน้าที่</NavDropdown.Item>:"")}
                                {(GetRole() === 99?<NavDropdown.Item href="/User/Online">ข้อมูลผู้ใช้งาน Online</NavDropdown.Item>:"")}
                              
                                {(GetRole() === 9?<NavDropdown.Divider />:"")}
                                <NavDropdown.Item onClick={()=>{_UserChangePassword.current?.Show();}}>เปลี่ยนรหัสผ่าน</NavDropdown.Item>
                                <NavDropdown.Item onClick={()=>{Logout();}}>
                                    ออกจากระบบ
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
        <UserChagePassword ref={_UserChangePassword} />
        </>
    )
}

export default Header;

